import { NextEditorPlugin } from '@atlaskit/editor-common/types';

import { createPlugin } from './pm-plugin';

export type Config = {
  filePath: string | undefined;
};

/**
 * This plugin adds support to automatically convert code blocks inserted
 * that don't have an existing language to use the language based on the file
 * path commenting on by default
 */
export const defaultCodeBlockLanguagePlugin: NextEditorPlugin<
  'autoCodeBlockLanguage',
  {
    pluginConfiguration: Config;
  }
> = ({ config }) => {
  return {
    name: 'autoCodeBlockLanguage',
    pmPlugins: () => {
      return [
        {
          name: 'autoCodeBlockLanguage',
          plugin: () => createPlugin(config),
        },
      ];
    },
  };
};
